import { render, staticRenderFns } from "./TripsHistoryTable.vue?vue&type=template&id=6634d5b0&scoped=true"
import script from "./TripsHistoryTable.vue?vue&type=script&lang=js"
export * from "./TripsHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./TripsHistoryTable.vue?vue&type=style&index=0&id=6634d5b0&prod&lang=scss"
import style1 from "./TripsHistoryTable.vue?vue&type=style&index=1&id=6634d5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6634d5b0",
  null
  
)

export default component.exports